module.exports = __webpack_public_path__ + "img/5.300dde1f.jpg";